import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-max-limit',
  templateUrl: './max-limit.component.html',
  styleUrls: ['./max-limit.component.scss']
})
export class MaxLimitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
